import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_PATIENT_GOALS } from '_api/queries/goal/useGetPatientGoals';
import { Goal, GoalPayload } from '_api/types';

export const CREATE_GOAL = 'create-goal';

export const useCreateGoal = () => {
  const queryClient = useQueryClient();
  return useApiMutation<Goal, GoalPayload>(
    () => '/goal/create-goal',
    'post',
    {},
    {
      mutationKey: [CREATE_GOAL],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_PATIENT_GOALS] });
      },
    },
    (body: GoalPayload) => JSON.stringify(body),
  );
};
